module.exports = __webpack_public_path__ + "img/modifiers-button.87451ed9.svg";